import { render, staticRenderFns } from "./ViewVideoModal.vue?vue&type=template&id=c5701770&"
import script from "./ViewVideoModal.vue?vue&type=script&lang=js&"
export * from "./ViewVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports